import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxchar'
})
export class MaxcharPipe implements PipeTransform {

  transform(value: string, limit: number = 100): string {
    if (!value) return '';
    if (value.length <= limit) return value;
    
    const lastDotIndex = value.lastIndexOf('.');
    
    // Check if file has a real extension (dot exists and isn't at start/end)
    if (lastDotIndex > 0 && lastDotIndex < value.length - 1) {
      // File has extension
      const extension = value.substring(lastDotIndex + 1);
      const filename = value.substring(0, lastDotIndex);
      const availableSpace = limit - extension.length - 4; // -4 for "..." and "."
      
      if (availableSpace > 0) {
        const truncated = filename.substring(0, availableSpace);
        return `${truncated}...${extension}`;
      }
    }
    
    // No extension or couldn't preserve extension - simple truncation
    return value.substring(0, limit - 3) + '...';
  }
}